

export const Scaler = {
  start(el, targetWidth, targetHeight) {
    this.targetWidth = targetWidth;
    this.targetHeight = targetHeight;

    function rescale() {
      const scale = Scaler.currentScale;
      const { x, y } = Scaler.currentTranslation;
      el.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    }
    
    window.addEventListener('resize', rescale);
    rescale();
  },

  getTransform() {
    const targetRatio = this.targetWidth / this.targetHeight;
    const currentRatio = window.innerWidth / window.innerHeight;

    let scale = 1.0;
    let translation = { x: 0, y: 0 };
    if (currentRatio > targetRatio) {
      scale = window.innerHeight / this.targetHeight;
      translation.x = (window.innerWidth - (this.targetWidth * scale)) / 2;
    } else {
      scale = window.innerWidth / this.targetWidth;
      translation.y = (window.innerHeight - (this.targetHeight * scale)) / 2;
    }

    return { scale, translation };
  },

  get currentScale() {
    const targetRatio = this.targetWidth / this.targetHeight;
    const currentRatio = window.innerWidth / window.innerHeight;

    if (currentRatio > targetRatio) {
      return window.innerHeight / this.targetHeight;
    } else {
      return window.innerWidth / this.targetWidth;
    }
  },

  get currentTranslation() {
    const targetRatio = this.targetWidth / this.targetHeight;
    const currentRatio = window.innerWidth / window.innerHeight;

    const translation = { x: 0, y: 0 };
    if (currentRatio > targetRatio) {
      translation.x = (window.innerWidth - (this.targetWidth * this.currentScale)) / 2;
    } else {
      translation.y = (window.innerHeight - (this.targetHeight * this.currentScale)) / 2;
    }

    return translation;
  },
};
